module.exports = __webpack_public_path__ + "img/pencil-portrait_jp.e84be97.jpg";